import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './ProjectWizard.html?raw';
import on from 'dojo/on';
import "../ProjectWizard/ProjectWizardTypes";

import _StatefulBase from '../../moreCore/UI/_StatefulBase/_StatefulBase';
import Edit from '../../moreCore/UI/Edit/Edit';
import '../../moreCore/UI/Edit/Edit';
import SelectBox from '../../moreCore/UI/SelectBox/SelectBox';
import '../../moreCore/UI/SelectBox/SelectBox';
import HintBox from '../../moreCore/UI/HintBox/HintBox';
import '../../moreCore/UI/HintBox/HintBox';
import GenericDialog from '../../moreCore/UI/GenericDialog/GenericDialog';
import '../../moreCore/UI/GenericDialog/GenericDialog';
import SelectEntityDialog from '../../moreCore/UI/SelectEntityDialog/SelectEntityDialog';
import "../../moreCore/UI/SelectEntityDialog/SelectEntityDialog";
import StaticTable from '../../moreCore/UI/StaticTable/StaticTable';
import "../../moreCore/UI/StaticTable/StaticTable";

import BookingList from '../ProjectWizard/BookingList/BookingList';
import "../ProjectWizard/BookingList/BookingList";
import _TabEnabledMixin from '../../moreCore/UI/Tabbing/_TabEnabledMixin';
import { EvBookingEditor, VAMtypes } from "../../WidgetCollection/_loadingHelpers/VAM";
import FloatingMenu from '../../moreCore/UI/Floating/Menu';
import FileUpload from '../../moreCore/UI/Filetransfer/FileUpload/FileUpload';
import FileUploadDisplay_ListRow from '../../moreCore/UI/Filetransfer/FileUpload/FileUploadDisplay_ListRow/FileUploadDisplay_ListRow';
import SearchSelect from '../../moreCore/UI/SearchSelect/SearchSelect';
import topic from 'dojo/topic';
import ExpandableSection from '../../moreCore/UI/Container/ExpandableSection';
import { ExpandableSectionMarkings } from "../../moreCore/UI/Container/ExpandableSectionTypes";
import EvProjectCopyForm from './CopyForm/EvProjectCopyForm';
import ProjectReportOptionsForm from './ProjectReportOptionsForm/ProjectReportOptionsForm';
import AddressWizard from '../AddressWizard/AddressWizard';
import Tooltip from '../../moreCore/UI/Floating/Tooltip';
import { VAM2types } from "../_loadingHelpers/VAMv2Types";
import OrchestraMatrix from '../OrchestraMatrix/OrchestraMatrix';
import OMplannedMusicianList from './PlannedMusician/PlannedMusicianList';
import CommdocListV1 from './Commdoc/CommdocList';
import NumberInput from '../../moreCore/UI/NumberInput/NumberInput';
import { AddressTypes } from "../_loadingHelpers/Address";


class ProjectWizard extends compose(_WidgetBaseSP, _TabEnabledMixin) {


    templateString: any = template;

    private evRoom: VAMtypes.EvRoom;

    formHeading: HTMLElement;
    bookingListContainer: HTMLElement;
    bookingList: MdsLax<InstanceType<typeof BookingList>>;

    plannedMusiciansContainer: HTMLElement;
    plannedMusicianList: MdsLax<InstanceType<typeof OMplannedMusicianList>>;

    projectTitle: MdsLax<InstanceType<typeof Edit>>;
    artisticPeriod: MdsLax<InstanceType<typeof SelectBox>>;
    financialPeriod: MdsLax<InstanceType<typeof SelectBox>>;
    projectType: MdsLax<InstanceType<typeof SelectBox>>;
    projectLeader: MdsLax<InstanceType<typeof HintBox>>;
    note: MdsLax<InstanceType<typeof Edit>>;
    promoter1: MdsLax<InstanceType<typeof HintBox>>;
    promoter2: MdsLax<InstanceType<typeof HintBox>>;

    fileUpload: MdsLax<InstanceType<typeof FileUpload>>;
    newUploadFiles: any[] = [];
    fileCategories: Array<{ ID: string, description: string }> = [];
    filesTable: MdsLax<InstanceType<typeof StaticTable>>;
    filesTableContainer: HTMLElement;
    filesSectionContainer: MdsLax<InstanceType<typeof ExpandableSection>>;

    commdocSectionContainer: MdsLax<InstanceType<typeof ExpandableSection>>;
    commdocSection: MdsLax<InstanceType<typeof CommdocListV1>> = null;

    saveButtonContainer: HTMLElement;

    private entityData: VAM2types.EvProjectEntity_Extended = null;
    private originalData: VAM2types.EvProjectEntity_Extended = null;
    private entityID: string = null;
    private _isDirty = false;

    caseEditingFields: Array<string> = ['projectTitle'];
    allValues: object = {};
    mandatoryFields: any = ["projectTitle"];
    _data_SelectionValues: Array<SelectionValueEntity>; //`?????
    selectEntityDlg: MdsLax<InstanceType<typeof SelectEntityDialog<AddressTypes.AddressEntity_Base>>>;
    previousSEDvalue: any;

    private artisticPeriodEntities: any = null;
    private isFinancialPeriodListReady: boolean = false;
    private isArtisticPeriodListReady: boolean = false;

    existingFilesTableLayout: StaticTable.RowConfig = {
        "attributes": ["filename", "keyword", "ref_file_category.description", "ref_entity_1.$ClassPrintname"],
        colNamesInternal: ["filename", "keyword", "ref_file_category.description", "Source", "Aktionen"],
        "colspans": [1, 1, 1, 1, 1],
        "headings": [(this as any).translations["General_Label_Filename"], (this as any).translations["General_Label_Keyword"], (this as any).translations["General_Label_Category"], (this as any).translations["General_Label_Source"], (this as any).translations["General_Label_Actions"]],
        widths: [null, null, null, "15ch"],
        alignmentsHeading: [null, null, null, null, "right"],
        alignmentsRow: [null, null, null, null, "right"]
    }

    table_formatterFunction(cell: StaticTable.StaticTableCell<object>): boolean {
        let node = cell.contentnode;
        let entity = cell.entity;
        let colName = cell.name;
        let value = cell.value;
        let rowIndex = cell.tableRow.rowGroup.rowIndex;

        switch (colName) {
            case "Aktionen":
                //this.UiModder.domAttr.set(cell.tableCellNode, "nowrap", true)
                let icon = this.createFontawesomeIcon("fas fa-download hoverTxtPrimary secondaryText w3-margin-right", "", node);
                on(icon, "click", lang.hitch(this, this._downloadFile, entity));

                let disabled = "";
                //if (!entity["ref_entity_1"] /*|| entity["ref_entity_1"]["ID"] !== this.currentData.ID*/) disabled = "w3-disabled";
                icon = this.createFontawesomeIcon(`fas fa-trash hoverTxtPrimary secondaryText warningTXT ${disabled}`, "", node);
                on(icon, "click", lang.hitch(this, this._deleteFile, entity));


                return true;
                break;

            case "Source":
                let sourceTooltip = new Tooltip();
                let fileEntity = entity as any;
                if (fileEntity && fileEntity.ref_entity_1) {
                    sourceTooltip.setup({
                        content: fileEntity.ref_entity_1?.$Displayname,
                        targetnode: node,
                        enableHover: true,
                        enableClick: true,
                        heading: value
                    });
                    node.innerHTML = this.createFontawesomeIcon("fas fa-info-circle", "&nbsp;").outerHTML + value;
                    return true;
                }
                else {
                    cell.value = null;
                    return false;
                }
                break;
        }

        return false;
    }

    private _downloadFile(file): void {
        console.debug("_downloadFile", file);
        window.open(window.appRoot + `EvBookingEditor/DownloadExistingFile?downloadKey=${file["ID"]}`)
    }

    private _deleteFile(file): void {

        let deletedFile = this.allValues["existingFiles"].filter(x => x["ID"] == file["ID"])[0];
        if (deletedFile) deletedFile["state"] = "deleted";

        this.drawTable(this.allValues["existingFiles"]);
        console.log("existingFiles", this.allValues["existingFiles"]);

        this.setDirty(true);
    }

    private drawTable(data: any): void {

        this.filesTableContainer.innerHTML = null;
        if (this.filesTable != null) this.filesTable.destroy();

        this.filesTable = new StaticTable();

        this.filesTable.setFormatter(lang.hitch(this, this.table_formatterFunction));
        this.filesTable.addLineConfig(this.existingFilesTableLayout);
        this.filesTable.setCyAttribute("ProjectWizardFilesTable");

        this.UiModder.domConstruct.place(this.filesTable.domNode, this.filesTableContainer);

        let list = data.filter(x => x["state"] != "deleted");

        this.filesTable.setData(list);

        this.filesSectionContainer.setMarking(list.length ? ExpandableSectionMarkings.hasContent : ExpandableSectionMarkings.default);
    }

    private _onClick_OpenPromoterSED(evt: MouseEvent,) {
        this.loadSelectEntityDialog(evt, "promoter1", this.promoter1);
    }

    private _onClick_OpenPromoter2SED(evt: MouseEvent,) {
        this.loadSelectEntityDialog(evt, "promoter2", this.promoter2);
    }

    private loadSelectEntityDialog(evt: MouseEvent, type: "promoter1" | "promoter2", targetInput: MdsLax<InstanceType<typeof HintBox>>) {

        let data = { "function": type };

        let url = window.appRoot + "ProjectWizard/GetSEDconfig";
        this.StandbyStart();
        this.RequestManager.post(
            url,
            {
                jsonData: JSON.stringify(data)
            },
            lang.hitch(this, this._onGetDlgConfig, targetInput),
            lang.hitch(this, this._onGetDlgConfigError),
            false // sync
        );
    }

    private _onGetDlgConfig(targetInput: MdsLax<InstanceType<typeof HintBox>>, data: any) {
        this.selectEntityDlg = new SelectEntityDialog();
        let dlg = this.selectEntityDlg;
        let addresscallback = null;
        if (this.hasFeature("Address/AddressWizard") && this.hasUserRole("Addresses_Create")) {
            addresscallback = lang.hitch(this, this._onClick_SED_CreateNewAddress, targetInput);
        };
        dlg.setConfiguration(
            data,
            lang.hitch(this, this._onCallback_Dlg, targetInput),
            addresscallback
        );
        //dlg.setValues(this.previousSEDvalue);
        dlg.show();
        this.StandbyStop();
    }

    private _onGetDlgConfigError(error: more.requestErrorMessage) {
        console.log("error", error)
        alert(error.Message);
    }

    private _onClick_SED_CreateNewAddress(targetInput: MdsLax<InstanceType<typeof HintBox>>) {


        if (this.selectEntityDlg) {
            let tree = this.selectEntityDlg.getSelectedTree();

            let addressWizard = new AddressWizard();

            let dlg = new GenericDialog();
            dlg.addWidgetToContent(addressWizard);
            dlg.keepOpen = true;
            dlg.destroyOnClose = false;


            switch (tree.name?.toLowerCase()) {
                case "organisation":
                case "organisations":
                case "company":

                    addressWizard.setup("organisation");
                    break;

                case "person":
                case "persons":
                    addressWizard.setup("person");
            }

            addressWizard.on("saved", lang.hitch(this, this._onAddressWizardSaved, dlg, addressWizard, targetInput));

            dlg.show(null, this.translations["Addresses__CreateNew"], null, null, "saveclose", lang.hitch(this, this._onAddressWizardDlgResult, dlg, addressWizard));
        }

    }

    private _onAddressWizardDlgResult(dlg: MdsLax<InstanceType<typeof GenericDialog>>, addressWizard: MdsLax<InstanceType<typeof AddressWizard>>, result: number) {
        if (result >= 1) { // OK/JA
            // speicherversuch
            if (addressWizard.submitFormData()) {
                dlg.disableAllButtons();
                setTimeout(lang.hitch(dlg, dlg.disableAllButtons, false), 10000); // unschön, aber falls was is, einen save-Error bekommen wir nicht mit...
            }
        } else {
            dlg.close(-1, true);
        }
    }

    private _onAddressWizardSaved(dlg: MdsLax<InstanceType<typeof GenericDialog>>, addressWizard: MdsLax<InstanceType<typeof AddressWizard>>, targetInput: MdsLax<InstanceType<typeof HintBox>>) {

        let addressID = addressWizard.getEntityId();
        let displayname = addressWizard.getDisplayName();

        dlg.close(-1, true);

        let tmpEntity = {};
        tmpEntity[targetInput.valueAttribute] = addressID;
        tmpEntity[targetInput.labelAttribute] = displayname;


        targetInput.setValue(tmpEntity);
    }

    private _onCallback_Dlg(addressField: MdsLax<InstanceType<typeof HintBox>>, data, items) {
        if (!items || items.length == 0) return;

        let entity = {
            ID: items[0].entry.value, gDisp_1: items[0].entry.label
        }
        addressField.setValue(entity)
        //this.previousSEDvalue = items;
    }

    private ignoreDirty: boolean = false;
    private _setValues(entity: VAM2types.EvProjectEntity_Extended) {

        this.ignoreDirty = true;

        this.allValues["ID"] = entity.ID;
        this.entityID = entity.ID;
        this.entityData = entity;

        this.allValues["newUploadFiles"] = [];

        this._drawActionbuttons();

        if (entity.ID) {
            this.handleBookingList(entity);
            this.handlePlannedMusicianList();
        }

        this.projectTitle.setValue(entity.ev_project_name, false);
        if (entity.ref_artistic_period) {
            this.artisticPeriod.setValue(entity.ref_artistic_period.ID, false);
        }
        if (entity.ref_financial_period) {
            this.financialPeriod.setValue(entity.ref_financial_period.ID, false);
        }
        if (entity.ref_ev_project_type_2) {
            this.projectType.setValue(entity.ref_ev_project_type_2.ID, false);
        }

        this.projectLeader.setValue(entity.ref_projectleader, false);
        this.note.setValue(entity.note, false);
        if (entity.ref_promoter_1) {
            this.promoter1.setValue(entity.ref_promoter_1.ref_address, false);
        }
        if (entity.ref_promoter_2) {
            this.promoter2.setValue(entity.ref_promoter_2.ref_address, false);
        }

        if (entity.existingFiles) {
            this.drawTable(entity.existingFiles);
            this.allValues["existingFiles"] = entity.existingFiles;
        }



        let handle = on(this, "dirty", lang.hitch(this, this.setDirtyDelayed, false, 100));

        setTimeout(handle.remove, 2000);

        this.ignoreDirty = false;
    }

    private serializeData(): void {

    }

    getDisplayname(): string {
        return this.title;
    }

    getEntityId(): string {
        return this.allValues["ID"];
    }

    private _onBookingListLoaded(): void {

    }

    private handlePlannedMusicianList() {

        if (!this.hasUserRole("Projects_OM")) {
            this.UiModder.domConstruct.empty(this.plannedMusiciansContainer);
            this.plannedMusicianList = null;
            this.hideNode(this.plannedMusiciansContainer);
            return;
        }

        if (this.entityData.plannedMusicians) {

            this.plannedMusicianList = new OMplannedMusicianList();
            this.plannedMusicianList.setup(this.entityData.plannedMusicians, this.entityID);
            this.plannedMusicianList.placeAt(this.plannedMusiciansContainer);

            let expander = new ExpandableSection();
            expander.setup(this.plannedMusicianList.domNode, this.translate('General_Label_PlannedMusicians'));
            expander.placeAt(this.plannedMusiciansContainer);

            expander.setMarking(this.entityData.plannedMusicians.length ? ExpandableSectionMarkings.hasContent : ExpandableSectionMarkings.default);

            this.hideNode(this.plannedMusiciansContainer, false);
        }
    }

    private handleBookingList(project: VAM2types.EvProjectEntity_Base) {

        if (!this.hasUserRole("EvBooking_Read")) {
            this.UiModder.domConstruct.empty(this.bookingListContainer);
            this.bookingList = null;
            this.hideNode(this.bookingListContainer);
            return;
        }

        if (!this.bookingList) {
            this.bookingList = new BookingList();
            this.UiModder.domConstruct.place(this.bookingList.domNode, this.bookingListContainer);
            this.bookingList.on("loaded", lang.hitch(this, this._onBookingListLoaded));
        }
        //this.UiModder.domConstruct.empty(this.bookingListContainer);

        this.hideNode(this.bookingListContainer, false);

        this.bookingList.loadData(project);
        this.bookingList.tabContainerName = this.getTabContainerName();

    }

    _setPromoter(address) { // ???
        switch (address["c_relation_type"]) {
            case "":
                break;
        }
    }

    isDirty() {
        return this._isDirty;
    }

    private dirtyTimeoutHandle: any = null;
    setDirtyDelayed(flag: boolean, timeout?: number) {

        if (this.dirtyTimeoutHandle != null) {
            clearTimeout(this.dirtyTimeoutHandle);
        }

        if (!timeout) {
            timeout = 1;
        }

        this.dirtyTimeoutHandle = setTimeout(lang.hitch(this, this.setDirty, flag));
    }

    setDirty(dirty: boolean) {
        if (this.ignoreDirty === true) return;
        this._isDirty = dirty;

        if (this.isEmbeddedInTab) {
            this.emitDirty(this._isDirty);
            this.requestContextButtonDisable("save", this._isDirty);
            this.requestContextButtonDisable("rollback", this._isDirty);
        }

    }

    save(): boolean {
        let flag = true;


        for (let i = 0; i < this.mandatoryFields.length; i++) {
            this[this.mandatoryFields[i]].setMandatory(true);
            this[this.mandatoryFields[i]].validateInput()
            if (!this[this.mandatoryFields[i]].validateInput()) {
                flag = false
                this[this.mandatoryFields[i]]["domNode"].scrollIntoView({ behavior: "smooth", block: "center" });
            }
        }

        if (flag && this.allValues) {
            this._saveProjectData();
        } else {
            this.showToast({
                title: this.translations["General_MandatoryMissing"],
                options: {
                    ID: "mandatoryFields",
                    timeout: 5000
                }, iconClass: toasterIcons.warning
            });
        }

        return flag;
    }

    private _saveProjectData() {

        if (!this.hasUserRole("Projects_Edit")) {
            return;
        }

        if (!this.entityID && !this.hasUserRole("Projects_Create")) {
            return;
        }

        var url = window.appRoot + "ProjectWizard/SaveProjectEntity";

        this.StandbyStart();

        this.RequestManager.post(
            url,
            {
                jsonData: JSON.stringify(this.allValues)
            },
            lang.hitch(this, this._onSaveProjectEntityResponse),
            lang.hitch(this, this._onSaveProjectEntityError),
            false // sync
        );
    }
    private _setHeading(title: string) {
        this.title = title;
        if (this.isEmbeddedInTab) {
            this.requestTabRename(title);
        }

        this.UiModder.domAttr.set(this.formHeading, "innerHTML", title);
        this.UiModder.domClass.toggle(this.formHeading, "w3-hide", !title);
    }

    loadProjectById(id: string, temporaryLabel?: string) {

        if (temporaryLabel) {
            this._setHeading(temporaryLabel);
        }

        if (!this.hasUserRole("Projects_Read")) {
            alert("no privilege - not allowed to load project")
            return;
        }

        this.entityID = id;

        this.StandbyStart();
        var url = window.appRoot + "ProjectWizard/GetProjectById";

        this.RequestManager.post(
            url,
            { jsonData: JSON.stringify({ id: id }) },
            lang.hitch(this, this._onGetProjectByIdResponse),
            lang.hitch(this, this._onGetProjectByIdError),
            false // sync
        );

    }

    private _getArtisticPeriod() {
        var url = window.appRoot + "ProjectWizard/GetArtisticPeriod";
        this.hourGlassStart(this.artisticPeriod);

        this.RequestManager.post(
            url,
            {},
            lang.hitch(this, this._onLoadArtisticPeriodResponse),
            lang.hitch(this, this._onLoadArtisticPeriodError),
            false // sync
        );
    }

    private _getFinancialPerdiod() {
        var url = window.appRoot + "ProjectWizard/GetFinancialPeriod";
        this.hourGlassStart(this.financialPeriod);

        this.RequestManager.post(
            url,
            {},
            lang.hitch(this, this._onLoadFinancialPeriodResponse),
            lang.hitch(this, this._onLoadFinancialPeriodError),
            false // sync
        );
    }

    private _getProjectType() {
        var url = window.appRoot + "ProjectWizard/GetProjectType";
        this.hourGlassStart(this.projectType);

        this.RequestManager.post(
            url,
            {},
            lang.hitch(this, this._onLoadProjectTypeResponse),
            lang.hitch(this, this._onLoadProjectTypeError),
            false // sync
        );
    }

    private _onGetProjectByIdResponse(entity: VAM2types.EvProjectEntity_Base) {

        this.originalData = lang.clone(entity);

        this._setValues(entity);

        this.webPrivilegeManager.loadPrivilegesForEntity(
            entity,
            lang.hitch(this,
                this._onPrivilegesLoaded)
        );

        this.StandbyStop();

    }

    private _onSaveProjectEntityResponse(response: VAM2types.EvProjectEntity_Base) {
        this.StandbyStop();
        this.showToast({
            title: this.translations["General_SavingSuccessful"],
            iconClass: toasterIcons.save,
            options: {
                ID: "saved",
                timeout: 5000
            }
        });

        this._setValues(response);
        this.fileUpload.resetFileUpload();
        this.newUploadFiles = [];
        this.emit("saveComplete");
        this.emit("saved");
        if (typeof (this.onEntityUpdated) == "function") {
            this.onEntityUpdated(this.entityData);
        }

        //if (this.isEmbeddedInTab)
        this.webPrivilegeManager.loadPrivilegesForEntity(
            response,
            lang.hitch(this,
                this._onPrivilegesLoaded),
                true
        );

    }

    private _onLoadArtisticPeriodResponse(response: Array<VAM2types.ArtisticPeriod>) {
        this._processSelectBoxValues(this.artisticPeriod, response, "description");
        this.hourGlassEnd(this.artisticPeriod);
        this.isArtisticPeriodListReady = true;
    }

    private _onLoadFinancialPeriodResponse(response) {
        this._processSelectBoxValues(this.financialPeriod, response, "description");
        this.hourGlassEnd(this.financialPeriod);
        this.isFinancialPeriodListReady = true;
    }

    private _onLoadProjectTypeResponse(response) {
        this.hourGlassEnd(this.projectType);
        this._processSelectBoxValues(this.projectType, response, "description");

    }

    private _onGetProjectByIdError(err: more.requestErrorMessage) {
        alert("ERROR beim _onGetProjectByIdError: " + err.Message);
    }

    private _onSaveProjectEntityError(err: more.requestErrorMessage) {
        alert("ERROR beim _onSaveProjectEntityError: " + err.Message);
    }

    private _onLoadArtisticPeriodError(err: more.requestErrorMessage) {
        alert("ERROR beim _onLoadArtisticPeriodError: " + err.Message);
    }

    private _onLoadFinancialPeriodError(err: more.requestErrorMessage) {
        alert("ERROR beim _onLoadFinancialPeriodError: " + err.Message);
    }

    private _onLoadProjectTypeError(err: more.requestErrorMessage) {
        alert("ERROR beim _onLoadFinancialPeriodError: " + err.Message);
    }

    private _onClick_Validate_Button() {

        this.UiModder.domClass.add(this.saveButtonContainer, "w3-disabled");
        setTimeout(lang.hitch(this, this.save), 150); // Achtung: Race condition scheinbar mit dem Dirty-Setter von Zeile
    }

    private _onClick_Rollback() {
        if (!this.entityData || !this.entityID) return;
        if (this.isDirty()) {
            this._onGetProjectByIdResponse(this.originalData);
        }
        this.UiModder.domClass.add(this.saveButtonContainer, "w3-disabled");

    }

    private _onClick_Delete_Button() {

        if (!this.hasUserRole("Projects_Delete")) {
            return;
        }

        let dlg = new GenericDialog();

        dlg.show(
            this.translations["General_ConfirmDeleteMessage"],
            this.title,
            this.translations["General_ConfirmDeleteSubtitle"],
            "fas fa-exclamation-triangle",
            "yesno",
            lang.hitch(this, this._onConfirmDeletion)
        );
    }

    private _onConfirmDeletion(result: number) {
        if (result >= 2) // ja
        {
            this.deleteEvProject();
        }
    }

    private deleteEvProject() {
        if (!this.entityID) {
            return;
        }

        if (!this.hasUserRole("Projects_Delete")) {
            return;
        }

        this.StandbyStart();

        let data = {
            entityID: this.entityID
        };

        let url = window.appRoot + "ProjectWizard/DeleteProject";

        this.RequestManager.post(
            url,
            {
                "jsonData": JSON.stringify(data)
            },
            lang.hitch(this, this._onDeleteProjectResponse),
            lang.hitch(this, this._onDeleteProjectError),
            false // sync
        );
    }

    onEntityUpdated: Function = null;

    private _onDeleteProjectResponse(response: { Exception: boolean, Message: string }) {

        topic.publish("EvProject/Deleted");

        this.setDirty(false);

        this.StandbyStop();

        if (typeof (this.onEntityUpdated) == "function") {
            this.onEntityUpdated(this.entityData);
        }

        this.emit("deleted");

        if (this.isEmbeddedInTab) {
            this.closeTab();
        }
    }

    private _onDeleteProjectError(error: more.requestErrorMessage) {
        this.StandbyStop();

        alert(error.Message);
    }

    private _onValueChange_promoter1() {
        this.addValue(this.promoter1);
    }

    private _onValueChange_promoter2() {
        this.addValue(this.promoter2);
    }

    private _onValueChange_projectType() {
        this.addValue(this.projectType);
    }

    private _onValueChange_projectLeader() {
        this.addValue(this.projectLeader);
    }

    private _onValueChange_projectTitle() {
        this.addValue(this.projectTitle);

        let title = this.projectTitle.getValue();
        if (!title) title = this.translations["Projects__UnnamedProject"];
        this._setHeading(title);
    }

    private _onValueChange_artisticPeriod() {
        this.addValue(this.artisticPeriod);

        let seasonID = this.artisticPeriod.getValue();
        if (!this.financialPeriod.getValue() && seasonID) {

            let season = this.artisticPeriodEntities.filter(x => x.ID == seasonID)[0];

            if (season["ref_financial_period"]) this.financialPeriod.setValue(season["ref_financial_period"]["ID"]);
        }
    }

    private _onValueChange_financialPeriod() {
        this.addValue(this.financialPeriod);
    }

    private _onValueChange_note() {
        this.addValue(this.note);
    }


    private addValue(input: MdsLax<InstanceType<typeof _StatefulBase>>): void {
        if (!this.hasUserRole("Projects_Edit")) {
            return;
        }
        this.setDirty(true);
        let widgetName: string = typeof this.getAttachPointNameForWidget(input) == "undefined"
            ? this.UiModder.domAttr.get(input.domNode, "name")
            : this.getAttachPointNameForWidget(input);
        if (input.getValue() && input.validateInput()) {
            let widgetValue: any = input.getValue();

            //if (this.caseEditingFields.indexOf(widgetName) != -1 && typeof widgetValue == 'string') {
            //    widgetValue = this._editCaseCamel(widgetValue);
            //}

            this.allValues[widgetName] = widgetValue;
        } else {
            delete this.allValues[widgetName];
        }
    }

    private getAttachPointNameForWidget(widget: MdsLax<InstanceType<typeof _StatefulBase>>): string {
        for (let attachPointName of this._attachPoints) {
            if (this[attachPointName] == widget) {
                return attachPointName;
            }
        }
    }

    private _editCaseCamel(value: string, eachWord: boolean = true): string {

        value = value.trim();

        if (value.length != 17 && value.indexOf(":") != 8) { // wenn das keine id ist
            let words: Array<string> = value.split(" ");
            let camelCasedWords: Array<string> = [];
            if (words && words.length && eachWord === true) {
                for (let word of words) {
                    let lowerCale: string = word.slice(1).toLowerCase();
                    let firstCase: string = word.slice(0, 1).toUpperCase();
                    camelCasedWords.push(firstCase + lowerCale);
                }

                return camelCasedWords.join(" ");
            } else {
                let lowerCale: string = value.slice(1).toLowerCase();
                let firstCase: string = value.slice(0, 1).toUpperCase();

                return firstCase + lowerCale;
            }
        } else {
            // sont unmodifiziert zurück geben
            return value;
        }
    }


    //showToast(message: string | false, ID: string, timeout?: number | false | "permanent", icon?: toasterIcons, extendedMessage?: string, options?: toastOptions) {

    //    let defaultIcon: toasterIcons = toasterIcons.confirmCheck;

    //    if (message === false) {
    //        this.toaster.removeToastById(ID);
    //    }
    //    else {

    //        if (typeof (icon) != "undefined") {
    //            defaultIcon = icon;
    //        }

    //        let defaultOptions: toastOptions = {
    //            closeButton: typeof (timeout) == "undefined" ? true : false, timeout: typeof (timeout) == "number" ? timeout : -1
    //        };

    //        if (typeof (options) != "undefined" && options != null) {
    //            defaultOptions = options;
    //        }

    //        defaultOptions.ID = ID;

    //        if (timeout === false) {
    //            //defaultOptions.close = true;
    //        } else if (typeof (timeout) == "number") {
    //            defaultOptions.timeout = timeout;
    //        }
    //        else if (timeout == "permanent") {
    //            defaultOptions.timeout = timeout;
    //        } else {
    //            defaultOptions.timeout = 5000;
    //        }

    //        if (extendedMessage != null && typeof (extendedMessage) != "undefined") {
    //            defaultOptions.onClick = {
    //                callback: lang.hitch(this, this.showErrorDetailsDlg, extendedMessage, message, null, "close", null)
    //            };

    //            this.toaster.addToast(message, defaultIcon, defaultOptions);
    //        }
    //        else {
    //            this.toaster.addToast(message, defaultIcon, defaultOptions);
    //        }
    //    }
    //}

    private showErrorDetailsDlg(message, header, subtitle, buttons, callback) {
        let dlg = new GenericDialog();
        dlg.show(message, header, subtitle, null, buttons, callback);
    }


    private _processSelectBoxValues(targetInput: MdsLax<InstanceType<typeof SelectBox>>, items, labelAttribute: string = "description", selectableAttribute: string = "is_active") {
        //set data for StateSelectbox
        if (targetInput == this.artisticPeriod) this.artisticPeriodEntities = items;

        for (let entity of items) {
            targetInput.addOption(entity.ID, entity[labelAttribute], true, selectableAttribute && typeof ((entity[selectableAttribute]) as boolean) == "boolean" ? entity[selectableAttribute] : true);
        }

        targetInput.setBlankOption("", "--");

        targetInput.constructOptions();

        targetInput.startup();

    }

    private _getSelectboxData() {
        this._getArtisticPeriod();
        this._getFinancialPerdiod();
        this._getProjectType();
    }
    _onCloseRequest() {
        let hasChanged = this.isDirty();

        if (hasChanged) {

            let dlgConfirm = new GenericDialog();
            dlgConfirm.show(this.translations["General_AskSavePendingChanges"],
                this.translations["General_PendingChanges"],
                "",
                "",
                "yesnocancel",
                lang.hitch(this, this._confirmCallback));

            return false;

        } else {
            return true;
        }
    }

    private _confirmCallback(result) {
        if (result == -1) { // nein
            this.closeTab();
        } else if (result == 0) { // cancel

        }
        else {
            this._onClick_Validate_Button();
            on(this, "saveComplete", lang.hitch(this, this.closeTab))
        }
    }

    _onEmbedding() {
        super._onEmbedding.apply(this, arguments as any);

        this._drawActionbuttons();

        if (this.isEmbeddedInTab) {
            this.hideNode(this.saveButtonContainer);
        }
    }
    private startCloneProcess(evt: MouseEvent) {
        if (!this.entityID) return;

        let dlg = new GenericDialog();

        let cloneForm = new EvProjectCopyForm();

        cloneForm.setup(this.entityData, this.bookingList.getEntityListData() as any, this.artisticPeriodEntities);

        dlg.show(cloneForm,
            this.translations["ProjectWizard__CopyEvProject"],
            null,
            null,
            "okcancel",
            lang.hitch(this, this._onCloneDlgResult, cloneForm, dlg));

        dlg._setOkBtnAttr(true, false); // ok anzeigen, aber disabled

        dlg.keepOpen = true;

        on(cloneForm, "result", lang.hitch(dlg, "_setOkBtnAttr", true)); // erster Parameter: anzeigen ja/nein, zweiter: enable Ja/nein

        dlg.show()


    }

    private startOrchestraEmploymentMatrix(evt: MouseEvent) {
        if (!this.entityID) return;

        let dlg = new GenericDialog();


        let form = new OrchestraMatrix();
        form.mainMenuGlobalSpaceNode = dlg.leftActionContainerNode; // hier kommt die OM-toolbar hin
        form.directProjectId = this.entityID;

        this.UiModder.domStyle.set(form.domNode, {
            height: "800px",
            width: "100%"
        });

        this.UiModder.domStyle.set(dlg.modalDlgContentNode, {
            width: "80%"
        });

        //form.setup(this.entityData, this.bookingList.getEntityListData() as any);

        dlg.show(form,
            this.translations["OM__SchedulerMatrix"],
            null,
            null,
            "close");

        //dlg.keepOpen = true;
        dlg.show()

        form.startup();
    }

    private _onCloneDlgResult(cloneForm: MdsLax<InstanceType<typeof EvProjectCopyForm>>, dlg: MdsLax<InstanceType<typeof GenericDialog>>, result: number) {
        if (result <= 0) {
            dlg.close(-1, true);
            return;
        }

        let data: VAM2types.CopyFormData_EvProject = cloneForm.getData();

        console.log("_onCloneDlgResult", data);

        dlg.disableAllButtons(true);
        this.StandbyStart(dlg.contentContainer);

        this.RequestManager.post(
            window.appRoot + "ProjectWizard/CopyEvProject",
            {
                "jsonData": JSON.stringify(data)
            },
            lang.hitch(this, this._onCopyEvProjectResponse, dlg, cloneForm),
            lang.hitch(this, this._onCopyEvProjectError, dlg)
        );
    }

    private _onCopyEvProjectResponse(dlg: MdsLax<InstanceType<typeof GenericDialog>>, cloneForm: MdsLax<InstanceType<typeof EvProjectCopyForm>>, response: VAMtypes.CopyFormResponse<VAMtypes.EvProjectEntity_Short>) {
        this.StandbyStop();

        if (response.result == "success") {
            dlg.close(1, true);

            this.emit("cloned");
            topic.publish("EvProject/Cloned");

            if (this.isEmbeddedInTab) {
                let newProject = new ProjectWizard();
                this.requestNewTabbedContent({
                    widget: newProject,
                    name: response.data.ID,
                    label: response.data.ev_project_name,
                    enableClosing: true,
                    sidebarEntryName: response.data.ID
                }, true);

                newProject.loadProjectById(response.data.ID);
            }
        }

        else {

            dlg.disableAllButtons(false);
        }
    }

    private _onCopyEvProjectError(dlg: MdsLax<InstanceType<typeof GenericDialog>>, error: more.requestErrorMessage) {
        this.StandbyStop();

        let errorDlg = new GenericDialog();
        errorDlg.show(error.Message, this.translations["General_SavingFailed"], null, toasterIcons.error);

        console.error(error.Message);

        dlg.disableAllButtons(false);

    }


    private _onClick_OpenReportMenu(evt: MouseEvent) {
        let menu = new FloatingMenu();

        menu.addEntry({
            label: this.translations["General_Label_ProjectReport"],
            callback: lang.hitch(this, this._onClick_ProjectReport, menu.domNode),
            icon: "fas fa-file-alt",
        });

        if (this.hasUserRole("_DEV") && this.getCurrentUserName() == "rj") {
            menu.addEntry({
                label: "Report der länger dauert (nur DEV rj)",
                callback: lang.hitch(this, this._onClick_ProjectReportDEV, menu.domNode),
                icon: "fas fa-stopwatch",
            });
        }

        menu.open(evt);
    }

    private _onClick_OpenCommdocsMenu(evt: MouseEvent) {
        let menu = new FloatingMenu();

        menu.addEntry({
            label: this.translations["General_Label_Offer"],
            callback: lang.hitch(this, this._prepareDataForCreateCommdoc, "project_offer"),
            icon: "fas fa-file-pdf",
        });
        menu.addEntry({
            label: this.translations["General_Label_Invoice"],
            callback: lang.hitch(this, this._prepareDataForCreateCommdoc, "project_invoice"),
            icon: "fas fa-file-pdf",
        });
        menu.addEntry({
            label: this.translations["General_Label_Advance"],
            //callback: lang.hitch(this, this._onClick_CreateCommdoc, "project_prepayment"),
            callback: lang.hitch(this, this._askForPercentageForPrepayment),
            icon: "fas fa-file-pdf",
        });

        menu.open(evt);
    }

    private _askForPercentageForPrepayment(): void {

        let dlg = new GenericDialog();

        let form = this.UiModder.domConstruct.create("div");
        let offerPrice = this.entityData["offer_price_total"] ? this.entityData["offer_price_total"] : 0.0;
        let prepaymentPrice = 0.0;

        let row = this.UiModder.domConstruct.create("div", {
            class: "w3-section w3-row w3-large",
            innerHTML: `${this.translate("ProjectWizard__commdocs_offerAmount")}: <b>${offerPrice} €</b>`
        }, form);

        row = this.UiModder.domConstruct.create("div", {
            class: "w3-row w3-padding",
        }, form);

        let numberInput = new NumberInput();
        numberInput.setMaxRange(100);
        numberInput.setMinRange(0);
        numberInput.setStep("0.01");

        numberInput.setLabel(this.translate("ProjectWizard__commdocs_label_setPercentage"));

        numberInput.placeAt(row);

        row = this.UiModder.domConstruct.create("div", {
            class: "w3-section w3-row w3-large",
            innerHTML: `${this.translate("ProjectWizard__commdocs_prepaymentPrognose")}: <b>${prepaymentPrice.toFixed(2)} €</b>`
        }, form);
        numberInput.on("change", () => {

            prepaymentPrice = offerPrice * numberInput.getValue() / 100;

            this.UiModder.domAttr.set(row, "innerHTML", `${this.translate("ProjectWizard__commdocs_prepaymentPrognose")}: <b>${prepaymentPrice.toFixed(2)} €</b>`)
        });

        dlg.show(form,
            this.translate("ProjectWizard__commdocs_setPercentage"),
            null, null,
            "okcancel",
            lang.hitch(this, this._sendDataForCommdoc, numberInput));
    }

    _sendDataForCommdoc(numberInput: MdsLax<InstanceType<typeof NumberInput>>, result): void {
        console.debug(numberInput, result);
        if (result !== 1) return;

        let percentage = numberInput.getValue();

        if (percentage <= 0 || percentage > 100) {

            this.showToast({
                title: this.translate("ProjectWizard__commdocs_setPercentage_errTitle"),
                message: this.translate("ProjectWizard__commdocs_setPercentage_errMessage"),
                iconClass: toasterIcons.notification,
                timeout: 20000
            });
            return;
        }

        this._prepareDataForCreateCommdoc("project_prepayment", percentage);
    }

    private _onClick_ProjectReportDEV(node: HTMLElement): void {

        let url = window.appRoot + "Downloads/ProjectReport";

        let data = { "projectID": this.allValues["ID"], "testProgressbar": true };
        let stringData = JSON.stringify(data);

        this.RequestManager.post(
            url,
            {
                jsonData: stringData
            },
            lang.hitch(this, this._onDownloadReady),
            lang.hitch(this, this._onRequestReportError),
            false // sync
        );

        this.StandbyStart(node);
    }

    private _onClick_ProjectReport(node: HTMLElement): void {
        this.StandbyStart();
        let url = window.appRoot + "Downloads/ProjectReport";

        if (this.hasFeature("EvProject/ProjectReportOptions") === true) {

            let optionsDlg = new ProjectReportOptionsForm();
            optionsDlg.displayOptionsDialog(this.allValues["ID"], lang.hitch(this, this._sendProjectRequest, url));
            optionsDlg.on("projectreport_cancelled", () => { this.StandbyStop(); });
            return;
        }

        let data = { "projectID": this.allValues["ID"] };
        let stringData = JSON.stringify(data);

        this._sendProjectRequest(url, stringData);
    }

    private _prepareDataForCreateCommdoc(type: "project_offer" | "project_invoice" | "project_prepayment", percentage?: number): void {

        let data = {
            "EvPlanningId": this.allValues["ID"],
            "type": type
        };
        //percentage
        if (type === "project_prepayment") data["percentage"] = percentage;

        let stringData = JSON.stringify(data);

        this._createCommdoc(stringData);
    }

    private _createCommdoc(data): void {


        this.StandbyStart();
        let url = window.appRoot + "ProjectWizard/CommdocCreateDocument";

        this._sendProjectRequest(url, data);
    }

    private _sendProjectRequest(url: string, stringData: string): void {

        this.RequestManager.post(
            url,
            {
                jsonData: stringData
            },
            lang.hitch(this, this._onDownloadReady),
            lang.hitch(this, this._onRequestReportError),
            false // sync
        );
    }

    private _onDownloadReady(entity: FileFinder.FileDescriptor) {
        this.StandbyStop();
        //console.log("_onClick_Download", entity);



        // timeout, sonst funktioniert das Standbystop nicht !?
        setTimeout(lang.hitch(this, function () {
            location.href = window.appRoot + this.stringFormat("FileDashboard/Download?downloadKey={0}&fileName={1}.{2}",
                entity.downloadKey,
                entity.filename,
                entity.extension);
        }), 600);
        setTimeout(lang.hitch(this, function () {
            this.loadProjectById(this.entityID);
            this.filesSectionContainer.toggleExpand(true);
        }), 1000);


    }

    private _onRequestReportError(error: more.requestErrorMessage) {
        this.StandbyStop();
        alert(error.Message);
    }

    private addDefaultCategoryToFile(file: { guid: string, filenames: string[] }): void {

        file["fileCategories"] = [];
        file["filenames"].forEach(fileName => {

            file["fileCategories"].push({
                fileName: fileName,
                category: this.fileCategories[0].ID
            });
        });
    }

    private _onChangeUploadFile(guid) {

        let newFilesArr = this.fileUpload.getValue();

        if (newFilesArr && this.fileUpload.validateInput()) {

            if (this.newUploadFiles.length === 0) {
                this.newUploadFiles = newFilesArr;
                this.newUploadFiles.forEach(file => {

                    this.addDefaultCategoryToFile(file);
                });

                this.allValues["newUploadFiles"] = this.newUploadFiles;
                console.debug("newUploadFiles_0", this.allValues["newUploadFiles"]);

                this.setDirty(true);
                return;
            }

            newFilesArr.forEach(file => {

                let guid = file.guid;
                let fileNames = file.filenames
                let existingFile = this.newUploadFiles.filter(x => x["guid"] === guid)[0];

                if (!existingFile) {

                    this.addDefaultCategoryToFile(file);

                    this.newUploadFiles.push(file);
                } else {

                    if (existingFile && existingFile["fileCategories"] && existingFile["fileCategories"].length > fileNames.length) {

                        let catToDelete = existingFile["filenames"].filter(x => fileNames.indexOf(x) === -1);

                        if (catToDelete) existingFile["fileCategories"].splice(existingFile["fileCategories"].indexOf(existingFile["fileCategories"].filter(x => x["fileName"] === catToDelete)[0]), 1);
                    }

                    if (!existingFile["fileCategories"] || existingFile["fileCategories"].length == 0) {

                        this.addDefaultCategoryToFile(existingFile);
                    }
                }
            });

            this.allValues["newUploadFiles"] = this.newUploadFiles;
            this.setDirty(true);
        } else {

            this.newUploadFiles = [];
            delete this.allValues["newUploadFiles"];
            this.setDirty(true);
        }

        console.debug("newUploadFiles", this.allValues["newUploadFiles"]);
    }

    private _loadFileCategoriesList(): void {

        let requestUrl = window.appRoot + "ProjectWizard/GetFileCategoriesList";

        this.RequestManager.post(
            requestUrl,
            {
                jsonData: null
            },
            (response: any) => { this.fileCategories = response },
            (err: any) => { alert(err.Message) },
            false // sync
        );
    }

    protected setupSelectBoxInFileRow(evt: { name: string, row: MdsLax<InstanceType<typeof FileUploadDisplay_ListRow>> }): void {
        let fileRow = evt.row;
        console.debug("fileRow", fileRow);
        let selectBox = new SearchSelect();
        selectBox.setCyName("ProjectWizard:fileCategories");

        selectBox.labelAttribute = "description";
        selectBox.setLabel(this.translations["General_Label_Category"]);
        selectBox.setSelectionListLEGACY(this.fileCategories);

        let categoryToSet = this.fileCategories[0].ID;

        this.allValues["newUploadFiles"].forEach(file => {

            if (file["guid"] === fileRow.getData()["uploadGUID"]) {

                if (file["fileCategories"]) categoryToSet = file["fileCategories"].filter(x => x["fileName"] === fileRow.getData()["FileName"])[0]["category"];
            }
        });

        selectBox.setValue(categoryToSet, true);

        selectBox.on("change", lang.hitch(this, this.assingCategoryToNewFile, fileRow));

        fileRow.addContent_LEGACY(true, selectBox.domNode);
    }

    private assingCategoryToNewFile(fileRow: MdsLax<InstanceType<typeof FileUploadDisplay_ListRow>>, value: string): void {
        let rowFileGuid = fileRow.getData()["uploadGUID"];
        let rowFileName = fileRow.getData()["FileName"];
        let fileToSave = this.allValues["newUploadFiles"].filter(x => x["guid"] === rowFileGuid)[0];

        //if (fileToSave) fileToSave["fileCategoryID"] = value;
        if (fileToSave) fileToSave["fileCategories"].filter(x => x["fileName"] === rowFileName)[0]["category"] = value;

        console.debug("newUploadFiles", this.allValues["newUploadFiles"]);
    }

    private _onDeletePrivilege(hasPriv: boolean) {
        if (hasPriv && !!this.entityID) {
            this.createDefaultButton("delete", lang.hitch(this, this._onClick_Delete_Button));
        } else {
            this.requestContextButtonRemove("delete");
        }
    }
    private _onEditPrivilege(hasPriv: boolean) {
        if (hasPriv) {
            this.createDefaultButton("save", lang.hitch(this, this._onClick_Validate_Button), false);
            this.createDefaultButton("rollback", lang.hitch(this, this._onClick_Rollback), false);
        } else {
            this.requestContextButtonRemove("save");
            this.requestContextButtonRemove("rollback");
        }
    }
    private _onCreatePrivilege(hasPriv: boolean) {
        if (hasPriv) {
            this.createDefaultButton("save", lang.hitch(this, this._onClick_Validate_Button), false);
        } else {
            this.requestContextButtonRemove("save");
        }
    }
    private _onCommdocPrivilege(hasPriv: boolean) {
        if (hasPriv && this.hasFeature("EvProject/CommdocMenu")) {
            this.requestContextButton({
                callback: lang.hitch(this, this._onClick_OpenCommdocsMenu),
                label: this.translations["General_Label_Commdocs"],
                iconClass: "fas fa-file-alt",
                placement: "actionbar",
                permanent: false,
                name: "commdocs",
                enabled: !!this.entityID
            });
        } else {
            this.requestContextButtonRemove("commdocs");
        }
    }

    private _onClonePriv(hasPriv: boolean) {
        if (hasPriv) {
            this.requestContextButton({
                callback: lang.hitch(this, this.startCloneProcess),
                label: this.translations["ProjectWizard__CopyEvProject"],
                iconClass: "fas fa-clone",
                placement: "actionbar",
                permanent: false,
                name: "clone"
            });
        } else {
            this.requestContextButtonRemove("clone");
        }
    }
    private _onReportsPriv(hasPriv: boolean) {
        if (hasPriv) {
            this.requestContextButton({
                callback: lang.hitch(this, this._onClick_OpenReportMenu),
                label: this.translations["General_Label_Reports"],
                iconClass: "fas fa-print",
                placement: "actionbar",
                permanent: false,
                name: "reports"
            });
        } else {
            this.requestContextButtonRemove("reports");
        }
    }
    private _drawActionbuttons() {


        if (this.isEmbeddedInTab) {

            this.hasUserRole("Projects_Delete",
                lang.hitch(this, this._onDeletePrivilege),
                this.entityData);

            if (this.entityID) {
                this.hasUserRole("Projects_Edit",
                    lang.hitch(this, this._onEditPrivilege),
                    this.entityData)

                this.hasUserRole("Projects_Report",
                    lang.hitch(this, this._onReportsPriv),
                    this.entityData);

                this.hasUserRole(["Projects_Edit", "Commdoc_Create"],
                    lang.hitch(this, this._onCommdocPrivilege),
                    this.entityData);

                this.hasUserRole(["Projects_Create", "Projects_Edit"],
                    lang.hitch(this, this._onClonePriv),
                    this.entityData);

                if (this.hasUserRole(["OM", "OM_Matrix"])) {
                    this.requestContextButton({
                        callback: lang.hitch(this, this.startOrchestraEmploymentMatrix),
                        label: this.translations["OM__SchedulerMatrix"],
                        iconClass: "fas fa-border-none",
                        placement: "actionbar",
                        permanent: false,
                        name: "matrix"
                    });
                }

            } else {
                this.hasUserRole("Projects_Create",
                    lang.hitch(this, this._onCreatePrivilege),
                    this.entityData)
            }
        }

    }

    private _onPrivilegesLoaded(): void {
        let result = this.hasUserRole(
            ["Projects_Edit", "Projects_Read"],
            lang.hitch(this, this._enableEdit),
            this.entityData);
        //this._enableEdit(result);

        this._drawActionbuttons();

        this.setUpCommdocSection();

    }

    private _enableEdit(hasPrivilege) {

        let elements = document.querySelectorAll(".projectWizard *:is(input, select, textarea)");


        this.disableNode(this.projectTitle, !hasPrivilege);
        this.disableNode(this.promoter1, !hasPrivilege);
        this.disableNode(this.promoter2, !hasPrivilege);
        this.disableNode(this.note, !hasPrivilege);
        this.disableNode(this.artisticPeriod, !hasPrivilege);
        this.disableNode(this.financialPeriod, !hasPrivilege);
        this.disableNode(this.projectType, !hasPrivilege);
        this.disableNode(this.projectLeader, !hasPrivilege);

        this.hideNode(this.fileUpload, !hasPrivilege);



        if (!hasPrivilege) {

            this.promoter1.removeInlineButton("Promoter");
            this.promoter2.removeInlineButton("Promoter");

        } else {

            this.promoter1.addInlineButton(lang.hitch(this, this._onClick_OpenPromoterSED), "Promoter");
            this.promoter2.addInlineButton(lang.hitch(this, this._onClick_OpenPromoter2SED), "Promoter");

        }
    }

    setUpCommdocSection(): void {
        if (!this.hasFeature("EvProject/CommdocList")) return;

        this.UiModder.domClass.remove(this.commdocSectionContainer.domNode, "w3-hide");

        if (this.commdocSection != null) this.commdocSection.destroy();

        this.commdocSection = new CommdocListV1(this.entityID);
        this.commdocSectionContainer.setContent(this.commdocSection);
        this.commdocSection.on("SetupCommdocList", (isSth: boolean) => {

            this.commdocSectionContainer.setMarking(isSth ? ExpandableSectionMarkings.hasContent : ExpandableSectionMarkings.default);
        });
    }

    postCreate(): void {

        this.useStandbyManager = true;
        super.postCreate.apply(this, arguments as any);
        this._getSelectboxData();
        this.note.setValidationEnabled(false);

        this._loadFileCategoriesList();

        this._enableEdit(false);
        //topic.subscribe("FileUploadDisplay/NewRowCreated", lang.hitch(this, this.setupSelectBoxInFileRow)); // SUPER - zig Widgets hören dann drauf!

        //this.fileUpload.on("NewRowCreated", lang.hitch(this, this.setupSelectBoxInFileRow));

        this.promoter1.addAdditionalRequestParameter("function", "promoter1");
        this.promoter2.addAdditionalRequestParameter("function", "promoter2");
    }

    startup(): void {
        super.startup.apply(this, arguments as any);

        if (!this.entityID) {
            this.hasUserRole("Projects_Create", lang.hitch(this, this._enableEdit));
            // dummy: falls die Session noch nicht da ist, wird das Callback aufgerufen sobald sie geladen ist:
            this.hasUserRole("xxxDummy", lang.hitch(this, this._drawActionbuttons));
        }
        //this.hasUserRole("xxxDummy", lang.hitch(this, this._handlePrivileges));
    }
}

export default mdsWidget(ProjectWizard);
